import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import ServiceView from "../views/ServiceView.vue";
import ReviewView from "@/views/ReviewView.vue";

import ImpressumView from "@/views/ImpressumView.vue";
import DatenschutzView from "@/views/DataSecurityView.vue";
import ContactView from "@/views/ContactView.vue";
import AblaufView from "@/views/AblaufView.vue";

import {createRouter, createWebHistory} from "vue-router";

const routes = [
    {path: "/", name: "home", component: HomeView, meta: {title: "Home"}},

    {path: "/ueber", component: AboutView, meta: {title: "Über mich"}},
    {path: "/pakete", component: ServiceView, meta: {title: "Leistungen"}},
    {path: "/review", component: ReviewView, meta: {title: "Bewertungen"}},

    {path: "/impressum", component: ImpressumView, meta: {title: "Impressum"}},
    {path: "/datenschutz", component: DatenschutzView, meta: {title: "Datenschutz"}},

    {path: "/kontakt", component: ContactView, meta: {title: "Kontakt"}},
    {path: "/ablauf", component: AblaufView, meta: {title: "Ablauf"}},
];

const scrollBehavior = (to: any, from: any, savedPosition: any) => {

    // 1. HASH hat Priorität (wichtig!)
    if (to.hash) {
        return {
            el: to.hash,
            behavior: "smooth"
        };
    }

    // 2. Browser Zurück-Button
    if (savedPosition) {
        return savedPosition;
    }

    // 3. Default
    return {top: 0};
};

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior
});

export default router;
